import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import {computed} from "vue";
import {windows} from "@/components/common/window/Windows";
import _ from "lodash";
import {MorphFieldType} from "@/components/business/crud/interface/FieldType";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'MorphTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const label = computed(() => {
  return _.get(props.data, [
    props.propName,
    "name",
  ]);
})

const value = computed(() => {
  return _.get(props.data, [
    props.propName,
    "id",
  ]);
})

const type = computed(() => {
  return _.get(props.data, props.widget.modelNameProp);
})

function open() {
  if (value.value && type.value) {
    windows.open({
      content: {
        type: 'route',
        href: props.widget.models[type.value].basePath + "/view?id=" + value.value
      },
      title: props.info.title + '详情',
    });
  }
}


return (_ctx: any,_cache: any) => {
  return (type.value && value.value)
    ? (_openBlock(), _createBlock(ScBtn, {
        key: 0,
        handler: open,
        text: label.value || '',
        type: "link"
      }, null, 8, ["text"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(label.value), 1))
}
}

})